// Small helpers for building public URLs safely

// Base taken from the <base href="..."> in index.html, defaults to "/"
export const publicBase =
  (document.querySelector("base")?.getAttribute("href") || "/").replace(/\/+$/, "/");

// Joins a path to the public base, removing any accidental leading slashes
export const pub = (p) => `${publicBase}${String(p).replace(/^\/+/, "")}`;

// Optional helpers (exported in case you want them elsewhere)
export const slugify = (s = "") =>
  s.toString().trim().toLowerCase()
    .replace(/&/g, " and ")
    .replace(/\+/g, " plus ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");

// Fetch a JSON file from public/ and throw a helpful error if the server
// returned HTML (e.g., index.html) due to a bad path.
export async function fetchJsonOrThrow(url) {
  const res = await fetch(url, { cache: "no-store" });
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  if (!res.ok || !ct.includes("application/json")) {
    const snippet = await res.text().catch(() => "");
    throw new Error(`File missing or not JSON at ${url}\nFirst bytes: ${snippet.slice(0, 60)}`);
  }
  return res.json();
}



